module.exports = __webpack_public_path__ + "img/2PNG_Cover.b81646c0.jpg";